<template>
  <div class="swiper-container" :class="`carrossel${id}`">
    <div class="swiper-wrapper" role="list">
      <div class="swiper-slide p-1" role="listitem" v-for="(s, index) in itens" :key="index" :class="{small}">
        <a href="javascript:" @click="goTo(s)" class="card card-produto mb-0">
          <img :src="s.url_imagem || (base_cdn + '/static/imgs/default.png')" aria-hidden="true" :alt="s.nome_produto">
          <div class="text-dark">
            <div class="m-0 limite-1">{{s.nome_produto}}</div>
            <h6 class="font-weight-bold text-primary mb-0" v-if="s.valor > 0">
              <s class="text-secondary pr-1 small" v-if="s.valor_base > 0 && !small">{{s.valor_base | valor}}</s>
              <b class="text-primary">{{s.valor | valor}}</b>
            </h6>
            <h6 class="font-weight-bold text-primary limite-1 mb-0" v-html="s.descricao_produto || '&nbsp;'" v-else></h6>
          </div>
          <div class="px-2 mt-2" v-if="!small">
            <button class="btn btn-primary btn-sm btn-block">Adicionar</button>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
    import Swiper from 'swiper'
    import 'swiper/dist/css/swiper.css'

    export default {
      name: "carrosell",
      props: ['slides', 'small'],
      data() {
        return {
          id: this.$helpers.ID(),
          itens: [],
          url: ''
        }
      },

      methods: {
        goTo(s) {
          if (this.small) {
            this.$emit('selProduto', s);

          } else {
            this.$router.push(`${this.url}/categorias/?id=${s.id_categoria}&produto=${s.id_produto}`);
          }
        }
      },

      mounted() {
        this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
        this.itens = this.slides.slice(0, 8);
        this.$nextTick(() => {
          this.swiper = new Swiper(`.carrossel${this.id}`, {
            slidesPerView: 'auto',
            freeMode: true,
          });
        })
      },
    }
</script>

<style>
  .swiper-container {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 200px;
  }

  .swiper-slide.small {
    width: 130px;
  }

  .swiper-slide.small .card-produto img {
    height: 90px;
  }
</style>
